import {ValueObject} from '@s-ui/domain'

import {FilterPriceSearchValueObject} from '../../search/ValueObjects/FilterPriceSearchValueObject.js'

export class ListPriceRangeOptionsValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static empty() {
    return new ListPriceRangeOptionsValueObject({value: []})
  }

  static createFromApiResponse({items}) {
    if (!Array.isArray(items)) return ListPriceRangeOptionsValueObject.empty()

    const priceRanges = items.map(({from, to, label, labelAlt}) => {
      const priceSearch = FilterPriceSearchValueObject.create({price: {from, to}})
      return {priceSearch, label, labelAlt}
    })

    return new ListPriceRangeOptionsValueObject({value: priceRanges})
  }

  get value() {
    return this.#value.map(({priceSearch}) => priceSearch.value)
  }

  getFilterOptions() {
    return this.#value.map(({priceSearch, label}) => {
      const priceRange = priceSearch.value
      return {
        id: `id-${priceRange.from}-${priceRange.to}`,
        value: {from: priceRange.from, to: priceRange.to},
        label
      }
    })
  }

  getFilterOptionsWithFees() {
    return this.#value.map(({priceSearch, labelAlt}) => {
      const priceRange = priceSearch.value
      return {
        id: `id-${priceRange.from}-${priceRange.to}`,
        value: {from: priceRange.from, to: priceRange.to},
        label: labelAlt
      }
    })
  }

  get isEmpty() {
    return this.#value.length === 0
  }
}
